<template>
   <div class="site-header yo-max-w" v-if="$teras.app.device=='desktop'">
      <div class="row yo-padding-bottom-xs yo-align-right yo-display-flex">
         <el-form class="col s12 search-form" @submit.prevent="effettuaRicerca">
            <el-input class="col s6 offset-s6" v-model="cerca" size="small" label="Search">
               <template #suffix><i class="material-icons yo-pointer" @click="effettuaRicerca">search</i></template>
            </el-input>
         </el-form>
         <a href="https://academy.eflm.eu/secretariat" target="_blank" class="yo-margin-left-xs">
            <el-tooltip content="Login in the EFLM Academy area">
               <el-button type="primary" circle><template #icon><i class="material-icons">person</i></template></el-button>
            </el-tooltip>
         </a>
         <!--<el-menu class="site-navbar" mode="horizontal" :router="true" :ellipsis="false">
            <el-sub-menu index="">
               <template #title>Academy/EuSpLM area</template>
               <a href="https://academy.eflm.eu/secretariat/" target="_blank"><li class="el-menu-item">Academy/EuSpLM Login</li></a>
               <a href="https://academy.eflm.eu/treasury/" target="_blank"><li class="el-menu-item">Academy/EuSpLM Registration</li></a>
            </el-sub-menu>
         </el-menu>-->
      </div>
      <!--<el-form class="row yo-padding-bottom-xs yo-align-right" @submit.prevent="effettuaRicerca">
         <el-input class="col s6 offset-s6" v-model="cerca" size="small">
            <template #suffix><i class="material-icons">search</i></template>
         </el-input>
      </el-form>-->
      <div class="row">
         <div class="col s12 m2m">
            <router-link to="/"><img src="/images/logo.png" alt="EFLM" :width="$teras.app.width>=1100 ? '220' : '170'" :height="$teras.app.width>=1100 ? '49' : '42'" /></router-link>
         </div>
         <div class="col s12 m9m">
            <site-navbar />
         </div>
      </div>
   </div>
   <div class="site-header yo-max-w" v-else>
      <div class="row">
         <div class="yo-float-left">
            <router-link to="/"><img src="/images/logo.png" alt="EFLM" width="200" height="49" /></router-link>
         </div>
         <div class="yo-float-right"><hamburger-icon /></div>
      </div>
   </div>

   <el-drawer :show-close="false" @close="drawerClose" v-model="$teras.app.drawer" direction="ltr" modal-class="menu-overlay" size="80%" :with-header="false">
      <site-navbar />
   </el-drawer>
</template>
<script>
import { defineAsyncComponent } from "vue"
import { ElTooltip, ElForm, ElInput, ElDrawer, ElButton } from "element-plus"
export default {
   name: "site-header",
   components: {
      ElTooltip, ElForm, ElInput, ElDrawer, ElButton, 
      SiteNavbar: defineAsyncComponent(() => import("@/components/Site-navbar.vue")),
      HamburgerIcon: defineAsyncComponent(() => import("@/components/Teras/Menu-mobile-icon.vue")),
   },
   data(){
      return {
         cerca: ""
      }
   },
   watch: {
      "$route": "changeRoute"
   },
   methods: {
      changeRoute(){
         this.cerca= this.$route.name=="search" ? this.$route.params.ricerca : ""
      },
      effettuaRicerca(){
         /*if(process.env.NODE_ENV != "development"){
            this.$alert("The global search is currently under development. It will be available soon!", "Warning", { type: "warning", showClose: false })
            this.cerca= ""
            return;
         }*/
         
         this.$router.push("/search/"+this.cerca)
         //this.cerca= ""
      },
      drawerClose(){
         var menuIcon= document.getElementById('menu-mobile-icon')
         if(menuIcon!=undefined){
            menuIcon.classList.remove('active')
         }
      },
   }
}
</script>